import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadcrumbComponent from '../../../../components/Breadcrumb';

const ParameterView: React.FC = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const deptData = location.state?.dept;

    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h23",
            timeZone: "Asia/Kuala_Lumpur",
        }).replace(", ", " ");
    };

    function handleBack(): void {
        navigate(`/admin/parameter`);
    }

    const toolbarTemplate = () => {
        return (
            <>
                <Button label="Back" icon="pi pi-angle-right" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />
            </>
        );
    };
    const toolbarTopTemplate = () => {
        function handlePrint(): void {
            window.print();
        }

        return (
            <>
                <Button icon="pi pi-print" severity="danger" style={{ marginRight: '.1em' }} onClick={() => handlePrint()} />
                <Button label="Back" icon="pi pi-angle-right" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />
            </>
        );
    };

    return (

        <div className="dept-view">
            <div className="card-title">
                <h5>Department Details</h5>
                <BreadcrumbComponent />
            </div>
            <Toolbar end={toolbarTopTemplate} />
            <br />
            <div className="card">
                <Accordion activeIndex={0}>
                    <AccordionTab header="Department Information">
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label><strong>Department Code:</strong></label>
                                <p>{deptData?.departmentCode || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Department Category:</strong></label>
                                <p>{deptData?.departmentCategory || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Full Description:</strong></label>
                                <p>{deptData?.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Short Description:</strong></label>
                                <p>{deptData?.shortDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Status:</strong></label>
                                <p>{deptData?.recordStatus === "1" ? "Active" : "Inactive"}</p>
                            </div>
                            <div className="field col-12">
                                <label><strong>Address:</strong></label>
                                <p>{deptData?.address || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Country:</strong></label>
                                <p>{deptData?.countryCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>State:</strong></label>
                                <p>{deptData?.stateCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Postcode:</strong></label>
                                <p>{deptData?.postcode || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>District:</strong></label>
                                <p>{deptData?.districtCodeHasOne?.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>City:</strong></label>
                                <p>{deptData?.city || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Telephone No.:</strong></label>
                                <p>{deptData?.telephoneno || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Fax No.:</strong></label>
                                <p>{deptData?.faxNo || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Email:</strong></label>
                                <p>{deptData?.email || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Created By:</strong></label>
                                <p>
                                    {deptData?.insertByHasOne?.fullName || "N/A"} @{" "}
                                    {deptData?.insertDate ? formatDate(deptData.insertDate) : "N/A"}
                                </p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label><strong>Modified By:</strong></label>
                                <p>
                                    {deptData?.modifiedByHasOne?.fullName || "N/A"} @{" "}
                                    {deptData?.modifiedDate ? formatDate(deptData.modifiedDate) : "N/A"}
                                </p>
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>

            <Toolbar end={toolbarTemplate} />
        </div>

    );
};

export default ParameterView;